import { normalizeEmailAddress } from "@/lib/utils"

const NEWSLETTER_SIGNUP_EMAIL_KEY = "ca_newsletter_signup_email"
const NEWSLETTER_SIGNUP_EMAIL_EVENT = "ca_newsletter_signup_email_change"

/** The shared validate-or-null shape, answering "" rather than null because the
 * session-storage readers below treat the empty string as "nothing stored". */
export function normalizeNewsletterEmail(value: string | null | undefined) {
  return normalizeEmailAddress(value) ?? ""
}

export function storeNewsletterSignupEmail(email: string) {
  if (typeof window === "undefined") return
  const normalized = normalizeNewsletterEmail(email)
  if (!normalized) return
  window.sessionStorage.setItem(NEWSLETTER_SIGNUP_EMAIL_KEY, normalized)
  window.dispatchEvent(new Event(NEWSLETTER_SIGNUP_EMAIL_EVENT))
}

export function readNewsletterSignupEmail() {
  if (typeof window === "undefined") return ""
  return normalizeNewsletterEmail(window.sessionStorage.getItem(NEWSLETTER_SIGNUP_EMAIL_KEY))
}

export function clearNewsletterSignupEmail() {
  if (typeof window === "undefined") return
  window.sessionStorage.removeItem(NEWSLETTER_SIGNUP_EMAIL_KEY)
  window.dispatchEvent(new Event(NEWSLETTER_SIGNUP_EMAIL_EVENT))
}

export function subscribeNewsletterSignupEmail(onStoreChange: () => void) {
  if (typeof window === "undefined") return () => undefined
  window.addEventListener("storage", onStoreChange)
  window.addEventListener(NEWSLETTER_SIGNUP_EMAIL_EVENT, onStoreChange)
  return () => {
    window.removeEventListener("storage", onStoreChange)
    window.removeEventListener(NEWSLETTER_SIGNUP_EMAIL_EVENT, onStoreChange)
  }
}
